module.exports = __webpack_public_path__ + "img/formasPagamento.ee32e4a3.svg";